import React from 'react';
import {useIntl} from 'react-intl';

import ProductModel from 'coreClasses/product/ProductModel';
import {useProducts} from 'coreHooks';
import AddressModel from 'coreOrderModels/AddressModel';
import ShipmentModel from 'coreOrderModels/ShipmentModel';

import ProductData from 'brandComponents/ReturnAuthorizationCreateForm/Subcomponents/ProductData';

import messages from './messages';

import styles from './ExchangeProducts.module.scss';

const ExchangeProducts = ({exchangeProducts, returnOrder, step}) => {
	const intl = useIntl();

	const products: ProductModel[] = useProducts(exchangeProducts.map(p => p.newItemID));
	const shipment: ShipmentModel = returnOrder.getShipments()?.[0] || null;
	const shippingAddress: AddressModel = shipment?.getShippingAddress() || null;

	return (
		<div className={styles['step-2__exchange-products']}>
			<div className={styles['step-2__exchange-products-title-wrapper']}>
				<span className={styles['step-2__exchange-products-title']}>
					{intl.formatMessage(messages.productsToReturn)}
				</span>
			</div>
			{exchangeProducts.map((item, index) => (
				<div key={index} className={styles['step-2__exchange-products-product']}>
					<ProductData
						product={products[index]}
						item={returnOrder.getProductItem(item.lineItemID)}
						quantity={1}
						currency={returnOrder.getCurrency()}
						step={step}
						shippingCountryCode={shippingAddress?.getCountryCode()}
					/>
				</div>
			))}
		</div>
	);
};

export default ExchangeProducts;